import React, { useEffect, useState } from "react";
import { imgBaseUrl } from "../../api/api";
import { formatToDate } from "../master/FormatToDateTime";
import "./MessGuestCard1.css";

export default function MessGuestCard1({ data }) {
  const [setting, setSetting] = useState({});

  useEffect(() => {
    setSetting(JSON.parse(localStorage.getItem("setting") ?? {}));
  }, []);
  return (
    <>
      <style>
        {`
        .mess-id-card-horizontal-1::before{
            background-image: url(${imgBaseUrl + setting?.logo_img});  
        }
          `}
      </style>
      <div className="mess-id-card-horizontal-1 p-1">
        <div className="row justify-content-center g-1 overflow-hidden">
          <div className="col-12">
            <div className="d-flex align-items-center justify-content-center gap-1">
              <img
                src={imgBaseUrl + setting?.logo_img}
                style={{ width: "100px" }}
                alt=""
              />
              <div className="institute-details text-center">
                <h6 className="m-0 ri-20px">{setting?.name}</h6>
                <p className="m-0">
                  {setting?.village} {setting?.district} {setting?.state},{" "}
                  {setting?.pin_code}
                </p>
                <p className="m-0">
                  Contact : {setting?.mobile}
                  {setting?.secondary_mobile &&
                    `, ${setting?.secondary_mobile}`}{" "}
                </p>
                <p className="m-0">Email : {setting?.email}</p>
              </div>
            </div>
          </div>
          <div className="col-11 border-top"></div>
          <div className="col-12 ps-2 pe-3 m-0">
            <p className="admission-date m-0">
              Date : {formatToDate(data?.joining_date??data?.created_at)}
            </p>

            <div className="row m-0 p-0 mb-2 g-0 align-items-center mt-2">
              <div className="col-12 text-center">
                <span className="card_name">Mess Guest Card</span>
              </div>
              <div className="col-3 text-nowrap">Name</div>
              <div className="col-1">:</div>
              <div className="col-6 fw-bold p-0">{data?.name}</div>
              <div className="col-3 text-nowrap">Mobile No</div>
              <div className="col-1">:</div>
              <div className="col-6 fw-bold p-0">
                {data?.mobile}
              </div>
              <div className="col-3 text-nowrap">Address</div>
              <div className="col-1">:</div>
              <div className="col-6 fw-bold p-0">{data?.address}</div>
              <div className="col-3 text-nowrap">Days</div>
              <div className="col-1">:</div>
              <div className="col-6 fw-bold p-0">{data?.days}</div>
            </div>
          </div>
          <div className="text-end signature">
            <img src={imgBaseUrl + setting?.signature} alt="" />
            <p className="m-0">Auth. Signature</p>
          </div>
        </div>
      </div>
    </>
  );
}
